module.exports = __webpack_public_path__ + "giraffe.jpg?96b750f657f51ea6e5582c497258db47";